// Preserves the existing O17 vendor-type broadcast only. This is client-side
// routing isolation, NOT proof of server-side DB/actor authorization.
export function openLegacyRealtime(runtime, endpoint, socketFactory, onMessages, onStatus, events = window) {
  const disabled = (reason) => { onStatus({ isConnected: false, reason }); return () => {}; };
  if (runtime.profile.backend !== 'odoo17') return disabled('O19 live updates are disabled. Use Refresh.');
  if (!runtime.currentSession()) return disabled('Sign in to enable live updates.');
  if (!endpoint) return disabled('O17 socket URL is not configured. Use Refresh.');
  let url;
  try { url = new URL(endpoint); } catch { return disabled('O17 socket URL is invalid. Use Refresh.'); }
  if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash || url.pathname !== '/') {
    return disabled('O17 socket URL must be an explicit HTTPS origin. Use Refresh.');
  }
  const vendorType = runtime.session.vendorType.trim().toLowerCase();
  const channel = vendorType ? `in_progress.${vendorType}` : 'in_progress';
  const socket = socketFactory(url.origin, { path: '/socket.io/', autoConnect: false,
    transports: ['websocket'], reconnection: true, reconnectionAttempts: 20, reconnectionDelay: 1500 });
  let alive = true;
  let messages = [];
  const close = () => {
    alive = false;
    socket.removeAllListeners();
    socket.disconnect();
    events.removeEventListener('storage', checkSession);
    messages = [];
    onMessages(messages);
    onStatus({ isConnected: false, reason: 'Live updates stopped for this session. Use Refresh.' });
  };
  const checkSession = () => { if (!runtime.currentSession()) close(); };
  socket.on('connect', () => {
    if (!alive || !runtime.currentSession()) { close(); return; }
    socket.emit('subscribe', channel);
    onStatus({ isConnected: true, reason: 'O17 legacy vendor-type broadcast (not actor-authenticated).' });
  });
  socket.on('disconnect', () => onStatus({ isConnected: false, reason: 'O17 live updates disconnected. Use Refresh.' }));
  socket.on('connect_error', () => onStatus({ isConnected: false, reason: 'O17 live updates unavailable. Use Refresh.' }));
  socket.on('event_from_odoo', (message) => {
    if (!alive || !runtime.currentSession()) { close(); return; }
    if (message?.channel !== channel) return;
    messages = [...messages.slice(-99), message];
    onMessages(messages);
  });
  events.addEventListener('storage', checkSession);
  socket.connect();
  return close;
}
